import { useState, useEffect, useCallback } from "react";
import { X } from "lucide-react";
import axios from "axios";
import { logError } from "@/lib/logger";
import { API } from "@/App";

const AvailabilityBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [messages, setMessages] = useState([
    "Currently accepting bookings in NYC/NJ",
    "Available for travel nationwide",
    "Limited availability — Book in advance"
  ]);
  const [isActive, setIsActive] = useState(true);

  const fetchBanner = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/public/banner`);
      if (response.data) {
        setMessages((prev) => response.data.messages || prev);
        setIsActive(response.data.is_active !== false);
      }
    } catch (error) {
      logError("Failed to fetch banner, using defaults:", error);
    }
  }, []);

  useEffect(() => {
    // Check if banner was dismissed in this session
    const dismissed = sessionStorage.getItem("banner_dismissed");
    if (dismissed) {
      setIsVisible(false);
    }

    // Fetch banner content from API
    fetchBanner();
  }, [fetchBanner]);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem("banner_dismissed", "true");
  };

  if (!isVisible || !isActive) return null;

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-[60] bg-jade-deep overflow-hidden"
      data-testid="availability-banner"
    >
      <div className="relative h-8 flex items-center">
        {/* Scrolling content */}
        <div className="animate-marquee whitespace-nowrap flex items-center">
          {[...Array(4)].map((_, i) => (
            <span key={`marquee-${i}`} className="inline-flex items-center mx-8">
              {messages.map((message) => (
                <span key={message} className="inline-flex items-center">
                  <span className="w-2 h-2 bg-jade-text rounded-full mr-3 animate-pulse" />
                  <span className="font-body text-xs tracking-widest uppercase text-jade-text">
                    {message}
                  </span>
                  <span className="mx-8 text-jade-text">✦</span>
                </span>
              ))}
            </span>
          ))}
        </div>

        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center hover:bg-jade-text/10 rounded transition-colors text-jade-text"
          data-testid="banner-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AvailabilityBanner;
